/**
 * @GENERATED from Figma node 3638:51938
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const PdfBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#F25123"
      fillRule="evenodd"
      d="M8.684 7.263v9.474H12v-.012c2.867-.15 4.263-1.7 4.263-4.725 0-3.08-1.447-4.63-4.42-4.732v-.005zm1.895 1.58v6.315h.79v-.002l.157.002c1.316 0 1.926-.32 2.224-.618.299-.299.618-1.225.618-2.54s-.32-2.241-.618-2.54-.908-.618-2.224-.618q-.08 0-.158.002v-.002zM0 7.263v9.474h1.895v-3.158H4.42v-.01c.766-.047 1.48-.278 2.017-.815.61-.61.825-1.45.825-2.333s-.214-1.723-.825-2.333c-.537-.537-1.251-.768-2.017-.815v-.01zm1.895 1.58V12h2.212c.594 0 .86-.267.986-.392l.005-.006c.123-.123.428-.576.428-1.18 0-.605-.305-1.058-.428-1.181l-.006-.006c-.125-.126-.392-.393-.987-.393zM17.684 16.737V7.263H24v1.58h-4.421v2.525h4.105v1.58H19.58v3.789z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(PdfBright);
export { ForwardRef as PdfBright };
